// Sets the browser tab title. Prefixes with brand.
import { useEffect } from "react";

const BASE = "Steward Learning Cloud · SIHMT";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE}` : BASE;
  }, [title]);
}

export function setPageTitle(title) {
  document.title = title ? `${title} · ${BASE}` : BASE;
}
